// extracted by mini-css-extract-plugin
module.exports = {"main":"Intro_main__aXKeI","intro":"Intro_intro__RgmX1"};